export default "__VITE_ASSET__DDLUA3j$__"